export enum DaysOfWeeks {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

const daysOfWeeksLabels: Record<DaysOfWeeks, string> = {
  [DaysOfWeeks.Monday]: 'Segunda-feira',
  [DaysOfWeeks.Tuesday]: 'Terça-feira',
  [DaysOfWeeks.Wednesday]: 'Quarta-feira',
  [DaysOfWeeks.Thursday]: 'Quinta-feira',
  [DaysOfWeeks.Friday]: 'Sexta-feira',
  [DaysOfWeeks.Saturday]: 'Sábado',
  [DaysOfWeeks.Sunday]: 'Domingo',
};

const daysOfWeeksOrder = [
  DaysOfWeeks.Monday,
  DaysOfWeeks.Tuesday,
  DaysOfWeeks.Wednesday,
  DaysOfWeeks.Thursday,
  DaysOfWeeks.Friday,
  DaysOfWeeks.Saturday,
  DaysOfWeeks.Sunday,
] as const;

export function getDayOfWeekOrder(dayOfWeek?: DaysOfWeeks | number | string | null) {
  if (dayOfWeek === null || dayOfWeek === undefined) {
    return Number.MAX_SAFE_INTEGER;
  }

  if (typeof dayOfWeek === 'number') {
    return dayOfWeek >= 0 && dayOfWeek < daysOfWeeksOrder.length ? dayOfWeek : Number.MAX_SAFE_INTEGER;
  }

  const normalizedDayOfWeek = String(dayOfWeek);
  const enumIndex = daysOfWeeksOrder.findIndex((value) => value === normalizedDayOfWeek);

  if (enumIndex >= 0) {
    return enumIndex;
  }

  const numericDayOfWeek = Number(normalizedDayOfWeek);

  return !Number.isNaN(numericDayOfWeek) && numericDayOfWeek >= 0 && numericDayOfWeek < daysOfWeeksOrder.length
    ? numericDayOfWeek
    : Number.MAX_SAFE_INTEGER;
}

export function translateDayOfWeek(dayOfWeek?: DaysOfWeeks | number | string | null) {
  if (dayOfWeek === null || dayOfWeek === undefined) {
    return '';
  }

  if (typeof dayOfWeek === 'number') {
    const enumValue = daysOfWeeksOrder[dayOfWeek];

    return enumValue ? daysOfWeeksLabels[enumValue] : String(dayOfWeek);
  }

  const translatedLabel = daysOfWeeksLabels[dayOfWeek as DaysOfWeeks];

  if (translatedLabel) {
    return translatedLabel;
  }

  const numericDayOfWeek = Number(dayOfWeek);

  if (!Number.isNaN(numericDayOfWeek)) {
    const enumValue = daysOfWeeksOrder[numericDayOfWeek];

    return enumValue ? daysOfWeeksLabels[enumValue] : String(dayOfWeek);
  }

  return dayOfWeek;
}
